import { Box, Center, Flex, Image, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";

import survey from "../../../img/survey.svg";
import viewSurvey from "../../../img/survey_template.png";
import Adminroutes from "../routes";

const AdminSurvey = () => {
  const navigate = useNavigate();
  return (
    <>
      <Flex
        minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}
      >
        <Box
          width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>
        <Box width="100%">
          <AdminDashboardHeader />
          <Flex
            bg="#F9F8F8"
            justifyContent="center"
            alignItems="center"
            pt="30px"
            px={["20px", "30px"]}
            width={"100%"}
            height={"auto"}
            minHeight={"95vh"}
            maxHeight={"95vh"}
            overflowX={"scroll"}
            className="scroll-hidden"
          >
            <Box
              bg="white"
              height="26rem"
              width="auto"
              p="4rem"
              py="6rem"
              rounded="lg"
              shadow="sm"
            >
              <Text textAlign="center" fontSize="22px" fontWeight="700">
                Survey
              </Text>
              <Flex
                alignItems="center"
                gap="2rem"
                justifyContent="between"
                width="100%"
                h="auto"
                py="3rem"
              >
                <Box
                  textAlign="center"
                  onClick={() => navigate(Adminroutes.CreateSurvey)}
                  cursor="pointer"
                >
                  <Center
                    bg="white"
                    height="10rem"
                    width="10rem"
                    borderRadius="8px"
                    borderWidth="2px"
                    borderColor="#9E9E9E"
                  >
                    <Image src={survey} />
                  </Center>
                  {/* <Text fontSize="16px" lineHeight="26px" mt="1.4rem">Create Survey</Text> */}
                  <Text fontSize="16px" lineHeight="26px" mt="1.4rem">
                    Create Survey Template
                  </Text>
                </Box>
                <Box
                  textAlign="center"
                  onClick={() => navigate(Adminroutes.UseTemplate)}
                  cursor="pointer"
                >
                  <Center
                    bg="white"
                    height="10rem"
                    width="10rem"
                    borderRadius="8px"
                    borderWidth="2px"
                    borderColor="#9E9E9E"
                  >
                    <Image src={viewSurvey} />
                  </Center>
                  <Text fontSize="16px" lineHeight="26px" mt="1.4rem">
                    Use Survey Template
                  </Text>
                </Box>
                {/* <Box textAlign="center"  onClick={()=>(navigate(Adminroutes.CreateSurvey))} cursor="pointer">
                                  <Center bg="white" height="10rem" width="10rem" borderRadius="8px" borderWidth="2px" borderColor="#9E9E9E">
                                      <Image src={surveytemplate} />
                                  </Center>
                                <Text fontSize="16px" lineHeight="26px" mt="1.4rem">Create Survey</Text>
                            </Box> */}
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};

export default AdminSurvey;
